import { AxiosInstance } from 'axios';

import { requestInterceptor } from './request-handler.interceptors';
import { responseInterceptor } from './response-handler.interceptors';

export function onInitInterceptors(axiosInstance: AxiosInstance) {
    requestInterceptor(axiosInstance);
    responseInterceptor(axiosInstance);
}
